The response from the `uploadCandidate` mutation.
